import { object, ref, string, } from 'yup';
import passwordValidation from '@widgets/shared/passwordValidation';
const formSpec = {
    password: string()
        .required('This field is required'),
    newPassword: string()
        .required('This field is required')
        .matches(passwordValidation, 'Your password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one number.'),
    confirmPassword: string()
        .required('Please retype your password')
        .oneOf([ref('newPassword')], 'Passwords must match'),
};
export const changePasswordFormSchema = object(formSpec);
